import React, { useState, useEffect } from "react";
import mqtt from "mqtt";
import { useDispatch } from "react-redux";
import { generateUUID } from "utils/appUtil";
import moment from "moment";
import {
  getPagesRequestPublishTopic,
  getPageSubscriptionTopic,
  getPageRequestPublishTopic,
} from "hooks/MQTTConstants";
import { pushNotification } from "utils/notifications";
import { NetworkClient } from "models/network";

import useSocketActions from "./socketActions";

// TODO: remove this service

export default () => {
  const [client, setClient] = useState<NetworkClient>();
  const [connectedClient, setConnectedClient] = useState<NetworkClient>();
  const dispatch = useDispatch();

  const { handlePageResults } = useSocketActions();

  const mqttPublish = (topic: string, payload: string | Buffer) => {
    if (client) {
      client.publish(topic, JSON.stringify(payload), { qos: 1 }, (error) => {
        if (error) {
        }
      });
    }
  };

  const mqttSub = (topic: string | string[]) => {
    if (client) {
      client.subscribe(topic, { qos: 1 }, (error) => {
        if (error) {
          console.log("Subscribe to topics error", error);
          return;
        }
        console.log("Subsribed");
      });
    }
  };

  useEffect(() => {
    return () => {
      if (client) {
        client.end(undefined, undefined, () => {
          console.log("Connect");
        });
      }
    };
  }, []);

  const mqttConnect = () => {
    setClient(
      mqtt.connect(process.env.REACT_APP_BASE_WS_URL, {
        clientId: generateUUID(),
        username: "live",
        password: "beamL1ve",
      })
    );
  };

  useEffect(() => {
    if (client) {
      client.on("connect", () => {
        console.log("Connected");
        setConnectedClient(client);
      });
      client.on("error", (err) => {
        console.error("Connection error: ", err);
        client.end();
      });
      client.on("reconnect", () => {
        console.log("Reconnecting");
      });
      client.on("disconnect", () => {
        console.log("Disconnecting");
      });
      client.on("message", mqttMessageReceivedListener);
    }
  }, [client]);

  const processMessage = (
    updatedMessages: Array<MessageInfo>,
    payload: MessageInfo
  ): Array<object> => {
    const flag = payload.data?.flag;
    const originalPageMessageId = payload?.originalPageMessageId;
    if (flag === "replace") {
      let index = updatedMessages.findIndex((x) => {
        return x.id === originalPageMessageId;
      });
      updatedMessages[index] = payload;
    } else if (flag === "remove") {
      let index = updatedMessages.findIndex((x) => {
        return x.id === originalPageMessageId;
      });
      updatedMessages.splice(index, 1);
    } else updatedMessages.push(payload);
    return updatedMessages;
  };

  const processLastSent = (page) => {
    if (page) {
      let lastSent;
      const groups = page?.persistent?.static?.metadata?.members?.groups ?? {};
      const userGroups = [];
      Object.keys(groups).map((groupName) => {
        if (
          (groups[groupName]?.userIds ?? []).indexOf(
            localStorage.getItem("RID")
          ) !== -1
        )
          userGroups.push(groupName);
      });
      for (let group of ["members", ...userGroups]) {
        if (
          !lastSent ||
          new Date(
            page.nonpersistent?.dynamic?.metadata?.lastSent?.[group]
              ?.updatedAt ?? 1970
          ).getTime() > new Date(lastSent.updatedAt).getTime()
        ) {
          lastSent = page?.nonpersistent?.dynamic?.metadata?.lastSent?.[group];
        }
      }
      page.lastSent = lastSent;
      page.lastRead =
        page?.nonpersistent?.dynamic?.metadata?.lastReadUser?.[
          localStorage.getItem("RID")
        ];
      const memberActivity = Object.keys(
        page?.nonpersistent?.dynamic?.metadata?.lastReadUser ?? {}
      );
      let readBy = {};
      if (memberActivity) {
        memberActivity.map((x) => {
          if (
            page?.nonpersistent?.dynamic?.metadata?.lastReadUser?.[x]
              ?.pageMessageId ??
            false
          ) {
            if (
              !readBy[
                page?.nonpersistent?.dynamic?.metadata?.lastReadUser?.[x]
                  ?.pageMessageId
              ]
            )
              readBy[
                page?.nonpersistent?.dynamic?.metadata?.lastReadUser?.[
                  x
                ]?.pageMessageId
              ] = [];
            readBy[
              page?.nonpersistent?.dynamic?.metadata?.lastReadUser?.[x]
                ?.pageMessageId
            ].push(x);
          }
        });
      }
      page.currentUserRole =
        page?.persistent?.static?.metadata?.members?.users?.[
          localStorage.getItem("RID")
        ]?.role ?? "edit";
      page.readBy = readBy;
    }
    return page;
  };

  const mqttMessageReceivedListener = (topic: string, message: string) => {
    const payload = { topic, message: message.toString() };
    console.log(JSON.parse(payload.message));
    if (topic.includes("searchPageResult")) {
      handlePageResults(JSON.parse(payload.message).data.data);
    } else if (topic.includes("createMessageResult")) {
      handleTextMessage(payload);
    } else if (topic.includes("focusMap")) {
      dispatch(JSON.parse(message));
    } else if (topic.includes("pageTyping")) {
      dispatch({ type: "PAGE_TYPING", payload: JSON.parse(message) });
    } else if (topic.includes("videoJoin")) {
      console.log("here", payload);
      handleVideoJoinNotification(JSON.parse(payload.message).data);
    } else if (topic.includes("videoEnd")) {
      console.log("here", payload);
      handleVideoEndedNotification(JSON.parse(payload.message).data);
    } else if (topic.includes("saveRecording")) {
      console.log("here", payload);
      handleSaveVideoNotification(JSON.parse(payload.message).data);
    } else if (topic.includes("recordingMediaResult")) {
      console.log("here", payload);
      const recordingMedia = JSON.parse(payload.message).data;
      if (recordingMedia.status) {
        const url = recordingMedia.data.url;
        dispatch({ type: "SET_TWILIO_VIDEO_URL", payload: url });
      } else {
        pushNotification(
          "Video recording is being processed. Please try later after some time",
          "error",
          "TOP_CENTER",
          1000
        );
      }
    } else if (topic.includes("user")) {
      const topics = topic.split("/");
      console.log("topics", topics[4], topics[5], localStorage.getItem("UID"));
      if (topics[4] === localStorage.getItem("UID")) {
        console.log("notification intended for me");
      }
      if (topics[5] === "pageCreated") {
        client?.publish(
          getPagesRequestPublishTopic(),
          JSON.stringify({
            paths: [`$..members.users.${localStorage.getItem("RID")}`],
            returnPaths: ["$"],
            pagination: { offset: 0, limit: 200 },
          })
        );
      }
      if (topics[5] === "pageRemoved") {
        // PAGE_REMOVE
        let page = JSON.parse(payload.message).data;
        dispatch({ type: "PAGE_REMOVE", payload: { pageId: page.pageId } });
      } else if (topics[5] === "eventPageUpdated") {
        console.log("event page updated", JSON.parse(payload.message).data);

        client.subscribe(getPageSubscriptionTopic(), { qos: 1 }, (error) => {
          if (error) {
            console.log("Subscribe to topics error", error);
            return;
          }
          client.publish(
            getPageRequestPublishTopic(),
            JSON.stringify({
              id: JSON.parse(payload.message).data,
              data: {
                objectId: JSON.parse(payload.message).data,
                paths: ["$"],
                returnPaths: ["$"],
                resultType: "value",
              },
            })
          );
        });
      }
    } else if (topic.includes("searchInPage/reply")) {
      console.log("search in page", JSON.parse(payload.message).id);
      let page = JSON.parse(payload.message).response.data?.[0]?.[0];
      console.log("page here", page);
      page = processLastSent(page);
      dispatch({
        type: "PAGE_UPDATE",
        payload: { pageId: JSON.parse(payload.message).id, ...page },
      });
    } else if (topic.includes("searchMessage/reply")) {
      let messages = JSON.parse(payload.message).response.data;
      let updatedMessages = [];
      let pageId;
      messages = messages.map((message) => {
        return message[Object.keys(message)[0]][0][0];
      });

      messages.sort((a, b) =>
        a.pageInfo.pageMessageId > b.pageInfo.pageMessageId
          ? 1
          : b.pageInfo.pageMessageId > a.pageInfo.pageMessageId
          ? -1
          : 0
      );

      console.log('messages here', messages);

      for (let message of messages) {
        pageId = parseInt(message?.pageInfo?.pageId || '-1');
        if(pageId !== -1){
          message = {
            messageType: message.message.type,
            createdAt: message.pageInfo.createdAt,
            data: message.message.attributes,
            senderName: `user# ${message.pageInfo.userId}`,
            senderId: message.pageInfo.userId,
            message: message.message.attributes.body,
            id: message.pageInfo.pageMessageId,
          };
          // dispatch({type: 'SET_SELECTED_PAGE_MESSAGE', payload: message })
          updatedMessages = processMessage(updatedMessages, message);
        }
      }
      // console.log('processed list here')
      dispatch({
        type: "SET_MESSAGES",
        payload: { messages: updatedMessages, pageId },
      });
    } else if (topic.includes("get/places")) {
      dispatch({
        type: "ADD_MAP_PLACES",
        payload: JSON.parse(payload.message).data,
      });
    } else if (topic.includes("getTokenResult")) {
      dispatch({
        type: "SET_TWILIO_TOKEN",
        payload: JSON.parse(payload.message).data.data,
      });
    } else if (
      topic.includes("bds/nonpersistent/static/metadata/connections")
    ) {
      console.log("mqtt connection", JSON.parse(payload.message));
      dispatch({
        type: "SET_CONNECTION",
        payload: JSON.parse(payload.message).data.value,
      });
    }
  };

  const handleVideoJoinNotification = (data) => {
    console.log(data);
    let callNotification = {
      senderId: data.sender,
      page: {
        ...data.page.static,
        videoRoomId: data.page.dynamic.videoRoomId,
      },
    };
    dispatch({ type: "SET_INCOMING_CALL", payload: callNotification });
    console.log(callNotification);
  };

  const handleVideoEndedNotification = (data) => {
    console.log(data);
    let callNotification = {
      senderId: data.sender,
      page: {
        ...data.page.static,
        videoRoomId: data.page.dynamic.videoRoomId,
      },
    };
    dispatch({ type: "SET_INCOMING_CALL_ENDED", payload: undefined });
    console.log(callNotification);
  };

  const handleSaveVideoNotification = (data) => {
    console.log(data);
    let notification = {
      senderId: data.sender,
      page: {
        ...data.page.static,
        videoRoomId: data.page.dynamic.videoRoomId,
      },
    };
    dispatch({ type: "SET_SAVE_VIDEO_PROMPT", payload: notification });
    console.log(notification);
  };

  // const handlePageResults = (data) => {
  //   // move this layer into another service
  //   const organizedData = data.map(
  //     (page) =>
  //       page[Object.keys(page)[0]][0][0] &&
  //       page[Object.keys(page)[0]][0][0]?.persistent.static.title && {
  //         pageId: Object.keys(page)[0],
  //         ...page[Object.keys(page)[0]][0][0],
  //       }
  //   );
  //   const filteredData = organizedData
  //     .filter((data) => data)
  //     // .sort(
  //     //   (a, b) =>
  //     //     moment(
  //     //       b.persistent.dynamic?.metadata?.updatedAt ??
  //     //         b.persistent.static.createdAt
  //     //     ) -
  //     //     moment(
  //     //       a.persistent.dynamic?.metadata?.updatedAt ??
  //     //         a.persistent.static.createdAt
  //     //     )
  //     // );
  //   console.log("Orgaized Data", filteredData);
  //   if (filteredData && filteredData.length > 0) {
  //     dispatch({ type: "SET_SEARCH_RESULT", payload: filteredData });
  //   }
  // };

  const handleTextMessage = (payload) => {
    // const resp = JSON.parse(payload.message).response.data.messages[0];
    const resp = JSON.parse(payload.message).data;
    const pageId = resp.pageInfo.pageId;
    const message = {
      messageType: resp.message.type,
      createdAt: resp.pageInfo.publishedAt,
      data: resp.message.attributes,
      senderName: `user# ${resp.pageInfo.userId}`,
      senderId: resp.pageInfo.userId,
      message: resp.message.attributes.body,
      pageId,
      id: resp.pageInfo.pageMessageId,
    };
    dispatch({ type: "SET_SELECTED_PAGE_MESSAGE", payload: message });
    if (message.messageType === "place") {
      client.subscribe(
        `${process.env.REACT_APP_ECO_SYSTEM}/connection/${localStorage.getItem(
          "CID"
        )}/connection/${localStorage.getItem("CID")}/focusMap`,
        { qos: 1 },
        (error) => {}
      );
      client.publish(
        `${process.env.REACT_APP_ECO_SYSTEM}/connection/${localStorage.getItem(
          "CID"
        )}/connection/${localStorage.getItem("CID")}/focusMap`,
        JSON.stringify({
          type: "ADD_SELECTED_PLACES",
          payload: {
            ...message,
            id: message.id,
            name: message.message,
            objectType: "place",
          },
        })
      );
    }
  };

  return {
    client: connectedClient,
    connectMQTT: mqttConnect,
    mqttPublish,
  };
};
